// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"553ab0aa","667":"c294f757","977":"4d9db920"}[chunkId] + ".chunk.js";
};